import { i18n } from "@/config/i18n";
import { ANOMALY_KINDS } from "@/constants/anomalyTypes";

/** Color list
 * "#fff000", "#fd04fb", "#ff1f1f", "#ab63fa", "#c9b500", "#497a00",
 * "#6e4f00", "#b3ff87", "#aacc00", "#00781c", "#4fa4ff", "#0007c7",
 * "#fc614f", "#ab63fa", "#bb45ff", "#ffa8ec", "#cc0030"
 */
/** New Color list
 * "#ad0205", "#ff1f1f", "#de8385", "#f3bfc3", "#fa8925", "#d5fb00",
 * "#63db07", "#00781c", "#add2f8", "#6e4f00", "#bb45ff", "#882380",
 * "#fe00ec", "#0007c7", "#012c54", "#255b8f", "#204b75", "#4fa4ff"
 */

export const anomalyTypeColors = Object.freeze({
  [ANOMALY_KINDS.AXIAL_CRACK]: "#f3bfc3",
  [ANOMALY_KINDS.CIRCUMFERENTIAL_CRACK]: "#ff69b4",
  [ANOMALY_KINDS.LOCAL_LEACHING_OUT]: "#ff1f1f",
  [ANOMALY_KINDS.LOCAL_LEACHING_IN]: "#4fa4ff",
  [ANOMALY_KINDS.CLAMP]: "#d5fb00",
  [ANOMALY_KINDS.LEACHING]: "#de8385",
  [ANOMALY_KINDS.RADIAL_CRACK]: "#63db07",
  [ANOMALY_KINDS.APPD_TAKEOFF]: "#bb45ff",
  [ANOMALY_KINDS.DELAMINATION]: "#ad0205",
  [ANOMALY_KINDS.DIRT]: "#fa8925",
  [ANOMALY_KINDS.GAS]: "#882380",
  [ANOMALY_KINDS.WIRE_BREAK]: "#6e4f00",
  [ANOMALY_KINDS.CASING_TUBE]: "#012c54",
  [ANOMALY_KINDS.H2S]: "#0007c7",
  [ANOMALY_KINDS.UNKNOWN_ANOMALY]: "#00781c",
  [ANOMALY_KINDS.MISSING_WALL]: "#fe00ec",
  [ANOMALY_KINDS.INCREASE_MFW]: "#add2f8",
  [ANOMALY_KINDS.OTHER]: "#204b75",
  [ANOMALY_KINDS.AIR_VENT]: "#fff000",
  [ANOMALY_KINDS.MISSING_FW]: "#fd04fb",
  [ANOMALY_KINDS.MISSING_BW]: "#497a00",
  [ANOMALY_KINDS.CORROSION]: "#d2b48c",
  [ANOMALY_KINDS.CORROSION_INSIDE]: "#a0522d",
  [ANOMALY_KINDS.CORROSION_OUTSIDE]: "#706290",
  [ANOMALY_KINDS.CORROSION_PRODUCT]: "#b87333",
  [ANOMALY_KINDS.OVAL]: "#aacc00",
  [ANOMALY_KINDS.GREASE]: "#fc614f",
  [ANOMALY_KINDS.LEAKAGE]: "#ffa8ec",
  [ANOMALY_KINDS.DAMAGED_CEMENT]: "#255b8f",
  [ANOMALY_KINDS.MISSING_CEMENT]: "#ab63fa",
  [ANOMALY_KINDS.DAMAGED_COATING]: "#c97a5d",
  [ANOMALY_KINDS.MISSING_COATING]: "#e64500",
  [ANOMALY_KINDS.DAMAGED_LINER]: "#5fa6a6",
  [ANOMALY_KINDS.MISSING_LINER]: "#007f99",
  [ANOMALY_KINDS.REDUCED_WALL_THICKNESS]: "#c9b500",
  [ANOMALY_KINDS.DENT]: "#cc0030",
  [ANOMALY_KINDS.POSSIBLE_LEAKAGE]: "#e6e6fa",
  [ANOMALY_KINDS.CREASING]: "#808000",
  [ANOMALY_KINDS.DAMAGED_WALL_INSIDE]: "#bc8f8f",
  [ANOMALY_KINDS.DAMAGED_WALL_OUTSIDE]: "#a0522d",
  [ANOMALY_KINDS.SCALING]: "#8b0000",
});

export const qualityInfluenceColors = Object.freeze({
  dirt: "#fc614f",
  vuil: "#fc614f",
  gas: "#b3ff87",
  misalignment: "#0007c7",
  scheefstand: "#0007c7",
  unaffected: "#bb45ff",
  "niet beïnvloed": "#bb45ff",
  "corrosion product": "#b87333",
  corrosieproduct: "#b87333",
});

export const jointTypeColors = Object.freeze({
  Joint: { num: 1, text: "Joint", color: "#ff1f1f" },
  Weld: { num: 2, text: "Weld", color: "#00781c" },
  "Joint-Tensile": { num: 3, text: "Joint-Tensile", color: "#ab63fa" },
  "Unknown Joint": { num: 4, text: "Unknown Joint", color: "#0007c7" },
  "Axial Crack": { num: 5, text: "Axial Crack", color: "#c9b500" },
});

export const materialColors = Object.freeze({
  // Plastics
  PVC: { num: 1, text: "PVC", color: "#882380" },
  HDPE: { num: 2, text: "HDPE", color: "#cc0030" },
  PE: { num: 3, text: "PE", color: "#ffa8ec" },
  HPPE: { num: 4, text: "HPPE", color: "#bb45ff" },
  // Metals
  "Ductile Iron": { num: 5, text: "Ductile Iron", color: "#882380" },
  Steel: { num: 6, text: "Steel", color: "#fc614f" },
  "Cast Iron": { num: 7, text: "Cast Iron", color: "#0007c7" },
  "Stainless Steel": { num: 8, text: "Stainless Steel", color: "#4fa4ff" },
  "Carbon Steel": { num: 9, text: "Carbon Steel", color: "#00781c" },
  "Mild Steel": { num: 10, text: "Mild Steel", color: "#63db07" },
  // Cement
  AC: { num: 11, text: "AC", color: "#b3ff87" },
  // Concrete
  Concrete: { num: 12, text: "Concrete", color: "#6e4f00" },
  "Reinforced Concrete": {
    num: 13,
    text: "Reinforced Concrete",
    color: "#add2f8",
  },
  "Plate reinforced Concrete": {
    num: 14,
    text: "Plate reinforced Concrete",
    color: "#c9b500",
  },
  // Composites
  GRE: { num: 15, text: "GRE", color: "#fa8925" },
  // Unknown
  Unknown: { num: 16, text: "Unknown", color: "#ff1f1f" },

  "Sidero Cement": { num: 17, text: "Sidero Cement", color: "#ad0205" },
});

export const defectColors = Object.freeze({
  h2s: "rgba(252, 97, 79, 0.5)",
  local_leaching: "rgba(171, 99, 250, 0.5)",
  deformation: "rgba(182, 232, 128, 0.5)",
  joints_angle: "rgba(245, 168, 34, 0.5)",
  joints_gap_width: "rgba(255, 102, 146, 0.5)",
});

// road_type: "p", "r" or "s" are the values and they mean "Primary road", "Road", "Street"
export const roadTypeColors = Object.freeze({
  p: { num: 1, text: "Primary road", color: "#ff1f1f" },
  r: { num: 2, text: "Road", color: "#00781c" },
  s: { num: 3, text: "Street", color: "#ab63fa" },
  other: { num: 4, text: "Other", color: "#0007c7" },
});

// eslint-disable-next-line no-irregular-whitespace
// soil_type: "Zand"​​, "Moerig op zand"​​, "Zware Zavel","Lichte Zavel", "Klei", "Lichte Klei", "Zware Klei", "Veen"
export const soilTypeColors = Object.freeze({
  Zand: { num: 1, text: "Zand", color: "#ff1f1f" },
  "Moerig op zand": { num: 2, text: "Moerig op zand", color: "#00781c" },
  "Zware Zavel": { num: 3, text: "Zware Zavel", color: "#0007c7" },
  "Lichte Zavel": { num: 4, text: "Lichte Zavel", color: "#c9b500" },
  Klei: { num: 5, text: "Klei", color: "#4fa4ff" },
  "Lichte Klei": { num: 6, text: " LichteKlei", color: "#bb45ff" },
  "Zware Klei": { num: 7, text: "Zware Klei", color: "#6e4f00" },
  Veen: { num: 8, text: "Veen", color: "#fc614f" },
});

export const getUncertaintiesWithColors = (t) =>
  Object.freeze({
    ground_level: {
      text: t("uncertainties.ground_level"),
      color: "#636efa",
    },
    soil_density_dry: {
      text: t("uncertainties.soil_density_dry"),
      color: "#ef553b",
    },
    soil_density_wet: {
      text: t("uncertainties.soil_density_wet"),
      color: "#00cc96",
    },
    ground_water_level: {
      text: t("uncertainties.ground_water_level"),
      color: "#ab63fa",
    },
    material_density: {
      text: t("uncertainties.material_density"),
      color: "#ffa15a",
    },
    tensile_strength: {
      text: t("uncertainties.tensile_strength"),
      color: "#19d3f3",
    },
    pressure: {
      text: t("uncertainties.pressure"),
      color: "#ff6692",
    },
    joint_angle_vertical: {
      text: t("uncertainties.joint_angle_vertical"),
      color: "#b6e880",
    },
    road_distance: {
      text: t("uncertainties.road_distance"),
      color: "#ff97ff",
    },
    road_wheel_load: {
      text: t("uncertainties.road_wheel_load"),
      color: "#fecb52",
    },
    wall_thickness: {
      text: t("uncertainties.wall_thickness"),
      color: "#636efa",
    },
    none: { text: t("uncertainties.none"), color: "grey" },
  });

export const getRemainingLifeColor = (t) => [
  { color: "black", text: t("color_legends.unknown") },
  { color: "green", text: `> 20 ${t("color_legends.years")}` },
  { color: "yellow", text: `10-20 ${t("color_legends.years")}` },
  { color: "orange", text: `5-10 ${t("color_legends.years")}` },
  { color: "red", text: `0-5 ${t("color_legends.years")}` },
  { color: "purple", text: `< 0 ${t("color_legends.years")}` },
];

export const getDegradationColorPP = (t) => [
  {
    color: "black",
    text: t("color_legends.unknown"),
    textForPlastic: t("color_legends.unknown"),
  },
  { color: "green", text: "0-5%", textForPlastic: "0-50%" },
  { color: "yellow", text: "5-10%", textForPlastic: "50-75%" },
  { color: "orange", text: "10-25%", textForPlastic: "75-90%" },
  { color: "red", text: "25-40%", textForPlastic: "90-100%" },
  { color: "purple", text: ">40%", textForPlastic: ">100%" },
];

export const safetyLevels = Object.freeze([
  { index: 0, text: "unknown", color: "black" },
  { index: 1, text: "0 - 1", color: "red" },
  { index: 2, text: "1 - 1.5", color: "orange" },
  { index: 3, text: "1.5 - 2", color: "yellow" },
  { index: 4, text: " > 2", color: "green" },
]);

export function getDegradationColorJoints() {
  return [
    { color: "black", text: i18n.global.t("color_legends.unknown") },
    { color: "green", text: "0-50%" },
    { color: "yellow", text: "51-75%" },
    { color: "orange", text: "76-99%" },
    { color: "red", text: ">100%" },
  ];
}

// muted colour for map features without a value for the selected gradient mode
export const NO_DATA_COLOR = "#808080";

export const gradientColorArr = Object.freeze([
  "rgb(13, 8, 135)",
  "rgb(181, 18, 135)",
  "rgb(252, 230, 99)",
]);

export const gradientColorArrAngle = Object.freeze([
  "rgb(252, 230, 99)",
  "rgb(181, 18, 135)",
  "rgb(13, 8, 135)",
  "rgb(181, 18, 135)",
  "rgb(252, 230, 99)",
]);

export const gradientColorArrDegr = Object.freeze([
  "black",
  "green",
  "yellow",
  "orange",
  "red",
]);

export type EWBRange =
  | "1-10"
  | "11-20"
  | "21-30"
  | "31-40"
  | "41-50"
  | "51-60"
  | "61-70"
  | "71-80"
  | "81-90"
  | "91-100"
  | "100+";

// WIRE_BREAKS_RANGES is no longer used for coloring — colors are now interpolated
// from gradientColorArr via getReversedGradientColor. Kept for reference only.
// export const WIRE_BREAKS_RANGES: Record<EWBRange, string> = {
//   "1-10": "#008000",
//   "11-20": "#66b300",
//   "21-30": "#cce600",
//   "31-40": "#ffed00",
//   "41-50": "#ffc900",
//   "51-60": "#ffa500",
//   "61-70": "#ff6300",
//   "71-80": "#ff2100",
//   "81-90": "#e6001a",
//   "91-100": "#b3004d",
//   "100+": "#800080",
// };

/** Ordered list of all wire_breaks EWBRange labels, from lowest to highest. */
export const WIRE_BREAKS_ORDERED_RANGES: EWBRange[] = [
  "1-10", "11-20", "21-30", "31-40", "41-50",
  "51-60", "61-70", "71-80", "81-90", "91-100", "100+",
];

function numericToWireBreaksRange(n: number): EWBRange {
  if (n > 100) return "100+";
  if (n > 90)  return "91-100";
  if (n > 80)  return "81-90";
  if (n > 70)  return "71-80";
  if (n > 60)  return "61-70";
  if (n > 50)  return "51-60";
  if (n > 40)  return "41-50";
  if (n > 30)  return "31-40";
  if (n > 20)  return "21-30";
  if (n > 10)  return "11-20";
  return "1-10";
}

/** Maps any wire_breaks_count value (preset range, non-preset range string, number, null) to its EWBRange label. */
export function resolveWireBreaksRange(count: string | number | null | undefined): EWBRange | null {
  if (count === null || count === undefined) return null;
  if (typeof count === "number") return numericToWireBreaksRange(count);
  if ((WIRE_BREAKS_ORDERED_RANGES as string[]).includes(count)) return count as EWBRange;
  // Non-preset range like "42-60" — resolve via average of bounds
  if (count.includes("-")) {
    const parts = count.split("-");
    const avg = (Number(parts[0]) + Number(parts[1])) / 2;
    return numericToWireBreaksRange(avg);
  }
  const n = Number(count);
  if (!isNaN(n)) return numericToWireBreaksRange(n);
  return null;
}

/**
 * Converts a wire_breaks_count value to a numeric value in the 0–100 range.
 * - null/undefined → null
 * - "100+" → 100
 * - "a-b" range → average of bounds
 * - number → the number itself (clamped to 0–100)
 */
export function wireBreaksCountToNumeric(count: string | number | null | undefined): number | null {
  if (count === null || count === undefined) return null;
  if (typeof count === "number") return Math.min(100, Math.max(0, count));
  // "100+" — single boundary with "+"
  if (count.endsWith("+")) {
    const n = Number(count.slice(0, -1));
    if (!isNaN(n)) return Math.min(100, n);
  }
  // "a-b" range — average of bounds
  if (count.includes("-")) {
    const parts = count.split("-");
    const avg = (Number(parts[0]) + Number(parts[1])) / 2;
    if (!isNaN(avg)) return Math.min(100, Math.max(0, avg));
  }
  const n = Number(count);
  if (!isNaN(n)) return Math.min(100, Math.max(0, n));
  return null;
}

function parseRgb(rgb: string): [number, number, number] {
  const m = rgb.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
  if (!m) return [0, 0, 0];
  return [Number(m[1]), Number(m[2]), Number(m[3])];
}

function lerpColor(a: [number, number, number], b: [number, number, number], t: number): string {
  const r = Math.round(a[0] + (b[0] - a[0]) * t);
  const g = Math.round(a[1] + (b[1] - a[1]) * t);
  const bl = Math.round(a[2] + (b[2] - a[2]) * t);
  return `rgb(${r}, ${g}, ${bl})`;
}

/**
 * Returns a color from the reversed gradientColorArr scale where:
 * - value 0   → gradientColorArr[2] (yellow)
 * - value 50  → gradientColorArr[1] (pink/magenta)
 * - value 100 → gradientColorArr[0] (blue/violet)
 *
 * Mirrors the MapGradient reversed=true visual scale.
 */
export function getReversedGradientColor(value: number): string {
  const clamped = Math.min(100, Math.max(0, value));
  const c0 = parseRgb(gradientColorArr[2] as string); // yellow  — at value 0
  const c1 = parseRgb(gradientColorArr[1] as string); // magenta — at value 50
  const c2 = parseRgb(gradientColorArr[0] as string); // blue    — at value 100
  if (clamped <= 50) {
    return lerpColor(c0, c1, clamped / 50);
  } else {
    return lerpColor(c1, c2, (clamped - 50) / 50);
  }
}

export const wireBreaksBaseColor = '#24e3c6'
